import DynamicButton from "../../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton";
import DynamicDatatable from "../../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable";

const AffiliateMarketingCommission = ({ onClick }) => {

  const data = [
    { category: 'Electronics', desc: 'Devices such as smartphones, laptops and accessories', commissionRate: '5%' },
    { category: 'Fashion', desc: 'Apparel, footwear and accessories', commissionRate: '12%' },
    { category: 'Electronics', desc: 'Devices such as smartphones, laptops and accessories', commissionRate: '5%' },
  ]

  const columns = [
    { name: 'Category', selector: row => row.category },
    { name: 'Description', selector: row => row.desc },
    { name: 'Commission Rate (Default)', selector: row => row.commissionRate },
    { name: "Actions", cell: () => <div className="d-flex gap-2"><button style={{all: "unset"}}>Edit</button><button style={{all: "unset"}}>Deactivate</button></div> }
  ]

  return (
    <div>
      <div className="p-3 d-flex align-items-center justify-content-between bg-white shadow mt-3">
        <div className="fw-semibold fs-5">Commission Structure for Affiliate marketing</div>
        <DynamicButton theme="blue" onClick={() => onClick(prev => !prev)}>
          Add new
        </DynamicButton>
      </div>

      <DynamicDatatable data={data} columns={columns} type='yellow' pagination />
    </div>
  );
};

export default AffiliateMarketingCommission;